/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */

export type MilestoneType = (typeof MilestoneType)[keyof typeof MilestoneType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MilestoneType = {
  START: "START",
  DECISION: "DECISION",
  APPROVAL: "APPROVAL",
  AVAILABILITY: "AVAILABILITY",
  ACCEPTANCE: "ACCEPTANCE",
  COMPLETION: "COMPLETION",
  GATE_CHECKPOINT: "GATE_CHECKPOINT",
  GO_LIVE: "GO_LIVE",
  EXTERNAL_DEADLINE: "EXTERNAL_DEADLINE",
} as const;
